import { PageHero } from "../components/site/PageHero";
import { Commercial } from "../components/site/Feature";
import { Process } from "../components/site/Process";
import { CTABand } from "../components/site/CTABand";

export default function CommercialPage() {
  return (
    <>
      <PageHero
        eyebrow="Commercial HVAC"
        title="HVAC that keeps you open."
        subtitle="Reliable commercial HVAC services designed to support consistent temperature control for your property."
      />
      <Commercial />
      <Process />
      <CTABand />
    </>
  );
}
